// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-91dece22] .formulate-input-label {

    margin: 0;

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
[data-v-91dece22] .formulate-input-label--before {

    display: inline-block
}
.formulate-input-label--lg[data-v-91dece22] .formulate-input-label--before {

    margin-bottom: 1rem;

    font-family: Mont;

    line-height: 1.35;

    font-size: 1.375rem;

    font-weight: 700
}
.formulate-input-label--md[data-v-91dece22] .formulate-input-label--before {

    margin-bottom: 1rem;

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
.formulate-input-label--sm[data-v-91dece22] .formulate-input-label--before {

    margin-bottom: 0.25rem;

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
[data-v-91dece22] .formulate-input-link {

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity));

    text-decoration-line: underline;

    outline: 2px solid transparent;

    outline-offset: 2px
}
[data-v-91dece22] .formulate-input-help {

    margin-top: -0.25rem;

    margin-bottom: 1rem;

    --tw-text-opacity: 1;

    color: rgb(156 163 175 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
[data-v-91dece22] .formulate-input-errors {

    margin: 0;

    margin-top: 0.5rem;

    list-style-type: none;

    padding: 0;

    --tw-text-opacity: 1;

    color: rgb(216 0 3 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
.formulate-input[data-v-91dece22] {

    position: relative;

    margin-bottom: 2rem;

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity))
}
.formulate-input[data-v-91dece22][data-is-showing-errors='true'] input {

    border-top-width: 1px;

    border-bottom-width: 1px;

    --tw-border-opacity: 1;

    border-color: rgb(216 0 3 / var(--tw-border-opacity))
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/inputs/FormInput.vue"],"names":[],"mappings":";AA6EA;;IAAA,SAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAEA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAIA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAIA;;IAAA,sBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAKA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,+BAAA;;IAAA,8BAAA;;IAAA;AAAA;AAIA;;IAAA,oBAAA;;IAAA,mBAAA;;IAAA,oBAAA;;IAAA,gDAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAIA;;IAAA,SAAA;;IAAA,kBAAA;;IAAA,qBAAA;;IAAA,UAAA;;IAAA,oBAAA;;IAAA,4CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,mBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAIA;;IAAA,qBAAA;;IAAA,wBAAA;;IAAA,sBAAA;;IAAA;AAAA","sourcesContent":["<template>\n  <component\n    ref=\"formInput\"\n    :class=\"'formulate-input-label--' + labelSize\"\n    :is=\"componentType\"\n    :type=\"type\"\n    v-bind=\"$attrs\"\n    :value=\"value\"\n    :checked=\"checked\"\n    @option:selecting=\"$emit('option:selecting', $event)\"\n    @option:selected=\"$emit('option:selected', $event)\"\n    @go=\"$emit('go', $event)\"\n    @input=\"$emit('input', $event)\"\n  >\n    <template #prefix>\n      <slot name=\"prefix\"></slot>\n    </template>\n    <template #suffix>\n      <slot name=\"suffix\"></slot>\n    </template>\n  </component>\n</template>\n\n<script>\nimport { computed, ref } from '@vue/composition-api';\nimport CheckboxInput from '@/lego/components/inputs/box/CheckboxInput.vue';\nimport RadioInput from '@/lego/components/inputs/box/RadioInput.vue';\nimport TextInput from '@/lego/components/inputs/text/TextInput.vue';\nimport DateInput from '@/lego/components/inputs/date/DateInput.vue';\nimport FileInput from '@/lego/components/inputs/file/FileInput.vue';\n\nexport default {\n  props: {\n    type: {\n      type: String,\n      default: 'text',\n    },\n    labelSize: {\n      type: String,\n      default: 'lg',\n    },\n    value: {\n      type: String,\n    },\n    checked: {\n      type: Boolean,\n    },\n  },\n  setup(props, context) {\n    const formInput = ref();\n    const inputChildren = computed(() => formInput.value?.children);\n\n    return {\n      formInput,\n      inputChildren,\n      componentType: computed(\n        () =>\n          ({\n            checkbox: CheckboxInput,\n            radio: RadioInput,\n            text: TextInput,\n            email: TextInput,\n            select: TextInput,\n            date: DateInput,\n            triotecaSelect: TextInput,\n            phone: TextInput,\n            file: FileInput,\n          }[props.type])\n      ),\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n/deep/ .formulate-input {\n  &-label {\n    @apply style-body-sm m-0 text-neutral-ultradark;\n\n    &--before {\n      @apply inline-block;\n      .formulate-input-label--lg & {\n        @apply style-subtitle-sm-bold mb-xxxs;\n      }\n\n      .formulate-input-label--md & {\n        @apply style-body-sm mb-xxxs;\n      }\n\n      .formulate-input-label--sm & {\n        @apply style-overline mb-quark;\n      }\n    }\n  }\n  &-link {\n    @apply underline outline-none text-neutral-ultradark;\n  }\n\n  &-help {\n    @apply style-overline text-neutral-medium -mt-quark mb-xxxs;\n  }\n\n  &-errors {\n    @apply style-overline text-feedback-error-medium mt-nano m-0 p-0 list-none;\n  }\n}\n.formulate-input::v-deep {\n  @apply relative text-neutral-ultradark mb-xs;\n\n  &[data-is-showing-errors='true'] {\n    input {\n      @apply border-feedback-error-medium border-y-hairline;\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
